import React from 'react';

import {message} from 'antd';
import {observable} from "mobx";
import http from 'libs/http';

class Store {
  @observable addresses = [];
  @observable address = {};
  @observable index = 0;
  @observable isFetching = false;


  //获取地址列表
  fetchAddresses = () => {
    this.isFetching = true;
    return http.get('/api/front/customer/address/')
      .then(data => {
        this.addresses = data
      })
      .finally(() => this.isFetching = false)
  }

  updateAddress = (data) => {
    return http.post('/api/front/customer/address/', data)
      .then(res => {
        this.address = data

        if (data.id) {
          this.addresses[this.index] = data
        } else {
          this.addresses.push(data)
          //TODO 新增的需要返回id
        }
        message.success('地址保存成功！')
      })
      .finally(() => this.isFetching = false)
  }


  setDefault = () => {
    let data = Object.assign({}, this.addresses[this.index], {is_default: true})

    return http.patch('/api/front/customer/address/', data)
      .then(res => {
        this.addresses.map(v => v.is_default = false)
        this.addresses[this.index]['is_default'] = true
        message.success('默认地址修改成功！')
      })
      .finally(() => this.isFetching = false)
  }

  delAddress = (index) => {
    this.isFetching = true;
    http.delete('/api/front/customer/address/?id=' + this.addresses[index]['id'])
      .then(data => {
        this.addresses.splice(index, 1)
      })
      .finally(() => this.isFetching = false)
  }


}

export default new Store()


// 地址

// area: "中原区"
// city: "郑州市"
// customer_id: 947
// details: "XX路"
// id: 605
// is_default: true
// is_del: false
// name: "shen"
// phone: "18703644856"
// post: "450000"
// province: "河南省"
// remark: "测试"
